import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { HubHookFormInput, HubHookFormSwitch } from "../../components";
import { TESTING } from "../../constants/testing";

const AddWorkOrderTesting = () => {
  const { watch } = useFormContext();
  const testingQuantity = watch("testingQuantity");

  return (
    <Stack gap="15px">
      <HubHookFormSwitch
        name="testingQuantity"
        label="Custom Quantity"
        labelPlacement="end"
        disableHelperText
        fullWidth={false}
        required={false}
        isCheckbox
        formControlProps={{
          sx: { minWidth: "129px" },
        }}
        labelProps={{
          sx: { textWrap: "nowrap" },
        }}
      />
      <Stack gap="5px" direction="row">
        {TESTING.map((t, idx) => (
          <Stack direction="row" gap="5px" key={t?.label}>
            <HubHookFormInput
              name={`testing[${idx}].testId`}
              defaultValue={t.id}
              isNumber
              hidden
            />
            {testingQuantity ? (
              <HubHookFormInput
                name={`testing[${idx}].quantity`}
                placeholder="Quantity"
                shouldUnregister={false}
                label={t.label}
                useSetValue
                isNumber
              />
            ) : (
              <HubHookFormSwitch
                name={`testing[${idx}].quantity`}
                label={t.label}
                labelPlacement="end"
                disableHelperText
                fullWidth={false}
                required={false}
                shouldUnregister={false}
                isCheckbox
                formControlProps={{
                  sx: { minWidth: "129px" },
                }}
                labelProps={{
                  sx: { textWrap: "nowrap" },
                }}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default AddWorkOrderTesting;
